import { cva, type VariantProps } from "class-variance-authority";
import { Slot as SlotPrimitive } from "radix-ui";
import type * as React from "react";
import type { Ref } from "react";
import { cn } from "../../lib/utils";
const textVariants = cva("font-sans text-base text-gray-700 dark:text-gray-100", {
  variants: {
    variant: {
      default: "text-gray-700 dark:text-gray-100",
      modal: "text-gray-700 dark:text-gray-200"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
export interface TextProps extends React.HTMLAttributes<HTMLParagraphElement>, VariantProps<typeof textVariants> {
  asChild?: boolean;
  ref?: Ref<HTMLParagraphElement>;
}
const Text = ({
  className,
  asChild = false,
  variant,
  ref,
  ...props
}: TextProps) => {
  const Comp = asChild ? SlotPrimitive.Slot : "p";
  return <Comp className={cn(textVariants({
    variant
  }), className)} ref={ref} {...props} data-sentry-element="Comp" data-sentry-component="Text" data-sentry-source-file="text.tsx" />;
};
export { Text, textVariants };